import SliderArrow from '@components/SliderArrow';
import React, { useCallback, useMemo, useRef, useState } from 'react';
import { Pagination, Swiper as SwiperType } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { StyledSwiperWrapper } from './styled';

interface ISliderProps {
  children?: React.ReactNode;
  items: JSX.Element[];
}

const Slider:React.FC<ISliderProps> = (props) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const swiperRef = useRef<SwiperType>();

  const isFirst = useMemo(() => {
    return activeIndex === 0;
  }, [activeIndex]);

  const isLast = useMemo(() => {
    return activeIndex === props.items.length - 1;
  }, [activeIndex]);

  const handlePrev = useCallback(() => {
    if (!swiperRef.current) return;
    swiperRef.current.slidePrev();
  }, []);

  const handleNext = useCallback(() => {
    if (!swiperRef.current) return;
    swiperRef.current.slideNext();
  }, []);

  return (
    <StyledSwiperWrapper>
      <Swiper
        onBeforeInit={(swiper) => {
          swiperRef.current = swiper;
        }}
        modules={[Pagination]}
        pagination={{ clickable: true }}
        onSlideChange={(swiper) => setActiveIndex(swiper.activeIndex)}
      >
        {props.items.map((item, i) => (
          <SwiperSlide key={i}>
            {item}
          </SwiperSlide>
        ))}
      </Swiper>
      <SliderArrow disabled={isFirst} direction='prev' onClick={handlePrev} />
      <SliderArrow disabled={isLast} direction='next' onClick={handleNext} />
    </StyledSwiperWrapper>
  );
}

export default Slider;
